/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import { qreq } from "../../shared/qrequest";
import Alert from "../Alert";
import L from "../Lang"
import BaseCom from "../BaseCom";
import Breadcrumb from "../Breadcrumb";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import LoadingAlert from "../LoadingAlert";
import { SidebarGlobal } from "../_Sidebar";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import React from "react";
import SurveyAdminEditItem from "./SurveyAdminEditItem";
import { v4 as uuidv4 } from 'uuid';
import { Pop } from "../PopModal";
import SurveyAdminImportModal from "./SurveyAdminImportModal";

class SurveyAdminEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: null
        };
        this.form = React.createRef();
        this.triggerSubmit = this.triggerSubmit.bind(this);
        this.submit = this.submit.bind(this);
        this.publish = this.publish.bind(this);
        this.addPage = this.addPage.bind(this);
        this.movePage = this.movePage.bind(this);
        this.removePage = this.removePage.bind(this);
        this.reindexPages = this.reindexPages.bind(this);
        this.addPageItem = this.addPageItem.bind(this);
        this.editPageItem = this.editPageItem.bind(this);
        this.movePageItem = this.movePageItem.bind(this);
        this.removePageItem = this.removePageItem.bind(this);
        this.reindexPageItems = this.reindexPageItems.bind(this);
        this.load = this.load.bind(this);
        this.isTouched = this.isTouched.bind(this);
        this.showImport = this.showImport.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.loaded !== this.state.loaded || prevState.touched !== this.state.touched || prevState.published !== this.state.published) {
            SidebarGlobal.setSubNav(<div className="btn-group">
                <button type="button" className="btn btn-primary" onClick={() => this.triggerSubmit(false)}><Icon icon="faSave" /> <L>Save</L></button>
                <button type="button" className="btn btn-success" onClick={() => this.triggerSubmit(true)} disabled={!this.state.touched}><Icon icon="faSave" /> <L>Publish</L></button>
                <Link to="/survey" role="button" className="btn btn-secondary"><Icon icon="faClose" /> <L>Close</L></Link>
            </div>);
        }
    }

    load() {
        if (this.props.params.id) {
            qreq.get('/api/survey/get/' + this.props.params.id, j => {
                if (j.item)
                    this.setState({ item: j.item, loaded: true, touched: !j.item.published });
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        }
        else {
            this.setState({ item: { pages: [] }, loaded: true });
        }
        qreq.get('/api/survey/config', j => {
            if (j.item)
                this.setState({ config: j.item });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    addPage() {
        var item = { ...this.state.item };
        var lastIndex = 0;
        if (item.pages.length !== 0) {
            var last = item.pages[item.pages.length - 1];
            if (!last.toRemove)
                lastIndex = last.orderIndex;
        }
        item.pages.push({ key: uuidv4(), orderIndex: lastIndex + 1, items: [] });
        this.setState({ item: item });
    }

    triggerSubmit(publish) {
        if (publish) {
            this.publish();
            return;
        }
        this.form.current.requestSubmit();
    }

    movePage(i, d) {
        var find = this.state.item.pages.find(a => a.orderIndex === d);
        if (find) {
            find.orderIndex = i.orderIndex;
            i.orderIndex = d;
            this.state.item.pages.sort((a, b) => a.orderIndex - b.orderIndex);
            this.setState({ item: { ...this.state.item } });
            this.isTouched();
        }
    }

    removePage(i) {
        i.toRemove = true;
        i.orderIndex = -1;
        this.reindexPages();
        this.isTouched();
    }

    addPageItem(i) {
        var lastIndex = 0;
        if (i.items.length !== 0) {
            var last = i.items[i.items.length - 1];
            if (!last.toRemove)
                lastIndex = last.orderIndex;
        }
        this.setState({ showItemEditModal: true, currentPage: i, currentItem: { key: uuidv4(), answers: [], orderIndex: lastIndex + 1 } });
        this.isTouched();
    }

    editPageItem(i, j) {
        this.setState({ showItemEditModal: true, currentPage: i, currentItem: j });
    }

    movePageItem(i, j, d) {
        var find = i.items.find(a => a.orderIndex === d);
        if (find) {
            find.orderIndex = j.orderIndex;
            j.orderIndex = d;
            i.items.sort((a, b) => a.orderIndex - b.orderIndex);
            this.setState({ item: { ...this.state.item } });
            this.isTouched();
        }
    }

    reindexPages() {
        var item = { ...this.state.item };
        var n = 1;
        item.pages.forEach(k => {
            if (k.toRemove) return;
            k.orderIndex = n;
            n++;
        });
        this.setState({ item: item });
        this.isTouched();
    }

    reindexPageItems(i) {
        var n = 1;
        i.items.forEach(k => {
            if (k.toRemove) return;
            k.orderIndex = n;
            n++;
        });
        this.setState({ item: { ...this.state.item } });
        this.isTouched();
    }

    removePageItem(i, j) {
        j.toRemove = true;
        j.orderIndex = -1;
        this.reindexPageItems(i);
        this.isTouched();
    }

    isTouched() {
        this.setState({ touched: true });
    }

    showImport() {
        if (!this.state.item.name || !this.state.item.ident)
            Pop.show(<><L>Please fill in a</L><strong><L>Survey Name</L></strong><L>and</L><strong><L>Survey URL Path</L></strong><L>before importing</L></>);
        else
            this.setState({ showImportModal: true });
    }

    publish() {
        Pop.showConfirm('Are you sure you want to publish this survey?', 'Publish', () => {
            this.submit(null, true);
        });
    }

    submit(e, publish, callback) {
        if (e) e.preventDefault();
        qreq.post('/api/survey/save', { ...this.state.item, published: publish ?? false }, j => {
            if (j.item) {
                this.setState({ item: j.item, touched: !j.item.published });
                if (publish)
                    this.success('Survey published!');
                else
                    this.success('Survey has been saved.');
                this.props.navigate('/survey/edit/' + j.item.surveyID);
                if (j.item.published)
                    this.load();
                if (callback)
                    callback(j.item.surveyID);
            }
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    render() {

        return <div className="container-fluid">
            <SurveyAdminEditItem item={this.state.currentItem}
                page={this.state.currentPage}
                show={this.state.showItemEditModal}
                onHide={() => this.setState({ showItemEditModal: false })}
                onSubmit={() => { this.setState({ item: { ...this.state.item } }); this.reindexPageItems(this.state.currentPage) }}
            />
            {this.state.item ?
                <SurveyAdminImportModal show={this.state.showImportModal}
                    surveyID={this.state.item.surveyID}
                    onHide={() => this.setState({ showImportModal: false })}
                    onSubmit={() => { this.load(); this.setState({ showImportModal: false }); }}
                    preImport={callback => this.submit(null, false, callback)}
                /> : ''}
            <h1><L>Survey Editor</L></h1>
            <Breadcrumb path={[['Surveys', '/survey'], ['Editor']]} />
            {this.state.item ? <form onSubmit={this.submit} ref={this.form}>
                <Card title="Info">
                    <FormInput model={this.state.item} name="name" type="text" label="Survey Name" required onChange={this.isTouched} />
                    <FormInput model={this.state.item} name="ident" type="text" label="Survey URL Path" required onChange={this.isTouched} />
                    {this.state.config && this.state.item.ident ? <div className="text-muted">{this.state.config.surveyUrl}/f/{this.state.item.ident}</div> : ''}
                </Card>
                <Card title="Pages" headerButtons={<div className="btn-group">
                    <button type="button" className="btn btn-primary" onClick={this.addPage}><Icon icon="faPlus" /> <L>Add Page</L></button>
                    <button type="button" className="btn btn-secondary" onClick={this.showImport}><Icon icon="faFileArrowUp" /> <L>Import</L></button>
                </div>}>
                    {this.state.item.pages.length === 0 ? <Alert><L>No pages.</L></Alert> :
                        <div className="row mx-2">
                            {this.state.item.pages.map(i => i.toRemove ? null : <div key={i.id ?? i.key} className="col-md-4">
                                <div className="d-flex bg-white p-3 border-1 my-2">
                                    <div className="fs-2">#{i.orderIndex}</div>
                                    <div className="mx-3 flex-fill">
                                        {i.items.length === 0 ? <Alert><L>No questions.</L></Alert> :
                                            <ul className="list-group">
                                                {i.items.map(j => j.toRemove ? null : <li key={j.id ?? j.key} className="list-group-item list-group-item-primary">
                                                    <div className="d-flex align-items-center">
                                                        <div className="mx-1">
                                                            <Icon icon={j.itemType === 'text' || j.itemType === 'email' || j.itemType === 'number' ? 'faComment' : j.itemType === 'textarea' ? 'faComments' :
                                                                j.itemType === 'radio' ? 'faCircleCheck' : 'faHandPointer'
                                                            } />
                                                        </div>
                                                        <div className="flex-fill" style={{ overflow: 'hidden', maxHeight: '5em', fontSize: '0.8em' }}>
                                                            {j.content}
                                                        </div>
                                                        <div className="text-end" style={{ minWidth: '100px' }}>
                                                            {j.orderIndex > 1 ? <button type="button" className="btn" onClick={() => this.movePageItem(i, j, j.orderIndex - 1)} title="Up"><Icon icon="faArrowUp" /></button> : ''}
                                                            {i.items.indexOf(j) < i.items.length - 1 ? <button type="button" className="btn" onClick={() => this.movePageItem(i, j, j.orderIndex + 1)} title="Down"><Icon icon="faArrowDown" /></button> : ''}
                                                            <button type="button" className="btn" onClick={() => this.editPageItem(i, j)} title="Edit Question"><Icon icon="faPencil" /></button>
                                                            <button type="button" className="btn" onClick={() => this.removePageItem(i, j)} title="Remove Question"><Icon icon="faTrash" /></button>
                                                        </div>
                                                    </div>
                                                </li>)}
                                            </ul>}
                                    </div>
                                    <div style={{ minWidth: '80px' }}>
                                        <div className="btn-group d-block d-flex justify-content-between">
                                            <button type="button" className="btn btn-primary" onClick={() => this.addPageItem(i)} title="Add Question"><Icon icon="faPlus" /></button>
                                            <button type="button" className="btn btn-danger" onClick={() => this.removePage(i)} title="Remove Page"><Icon icon="faTrash" /></button>
                                        </div>
                                        <div className="btn-group d-block mt-1 d-flex justify-content-between">
                                            {i.orderIndex > 1 ? <button type="button" className="btn btn-secondary" onClick={() => this.movePage(i, i.orderIndex - 1)} title="Move Page"><Icon icon="faCaretLeft" /></button> : ''}
                                            {this.state.item.pages.indexOf(i) < this.state.item.pages.length - 1 ? <button type="button" className="btn btn-secondary" onClick={() => this.movePage(i, i.orderIndex + 1)} title="Move Page"><Icon icon="faCaretRight" /></button> : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>)}
                        </div>}
                </Card>
            </form> : <LoadingAlert />}
        </div>;
    }
}

export default withParamsAndNavigate(SurveyAdminEdit);